import CloudFlyerAPI from '../api/CloudFlyerAPI'
import {receiveData, receiveError, requestData} from "../api/http";

export const REQUEST_ALERTS = 'REQUEST_ALERTS'
export const RECEIVE_ALERTS_SUCCESS = 'RECEIVE_ALERTS_SUCCESS'
export const RECEIVE_ALERTS_ERROR = 'RECEIVE_ALERTS_ERROR'
export const ADD_ALERT = 'ADD_ALERT'
export const EDIT_ALERT = 'EDIT_ALERT'
export const DELETE_ALERT = 'DELETE_ALERT'

const fakeAlerts = [
  {
    id: 1,
    type: 'SIZE',
    limit: 100
  },
  {
    id: 2,
    type: 'COST',
    limit: 10
  },
  {
    id: 3,
    type: 'SIZE',
    limit: 50
  }
]

export const fetchAlerts = () => {
  return dispatch => {
    dispatch(requestData(REQUEST_ALERTS))

    CloudFlyerAPI.notifications
      .all()
      .then(res =>{
        if(!res)
          return dispatch(receiveError(RECEIVE_ALERTS_ERROR))

        dispatch(receiveData(RECEIVE_ALERTS_SUCCESS, ((res||{}).data||{})))
      })
      .catch(e =>{
        dispatch(receiveError(RECEIVE_ALERTS_ERROR, e))
      })
  }
}


/*export const fetchAlerts = () => {
  return dispatch => {
    dispatch(requestAlerts())
    // FETCH API HERE
    setTimeout(() => dispatch(receiveAlerts(fakeAlerts)), 2000)
  }
}*/

const receiveAlerts = alerts => ({
  type: RECEIVE_ALERTS_SUCCESS,
  alerts
})

const requestAlerts = () => ({
  type: REQUEST_ALERTS
})

export const createAlert = alert => {
  return dispatch => {
    // CREATE API HERE
    setTimeout(() => dispatch(addAlert(alert)), 2000);
  }
}

export const addAlert = alert => ({
  type: ADD_ALERT,
  alert
})

export const updateAlert = alert => {
  return dispatch => {
    // UPDATE API HERE
    setTimeout(() => dispatch(editAlert(alert)), 2000)
  }
}

export const editAlert = alert => ({
  type: EDIT_ALERT,
  alert
})

export const removeAlert = id => {
  return dispatch => {
    // DELETE API HERE
    setTimeout(() => dispatch(deleteAlert(id)), 2000)
  }
}

export const deleteAlert = id => ({
  type: DELETE_ALERT,
  id
})
